import { createSelector } from 'reselect';

export const getState = (state = {}) => state.locator;

export const getMapState = createSelector(getState, (state = {}) => state.map);

export const getSearchState = createSelector(getState, (state = {}) => state.search);
